import * as Yup from 'yup';
export const validationSchema = Yup.object({
  name: Yup.string().required('Nome do canal é obrigatório'),
  phone: Yup.string().required('Telefone do canal é obrigatório'),
});
